module.exports = __webpack_public_path__ + "static/media/capital_group.a9a4b464.jpg";